var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: "Chỉnh sửa khoản thu học sinh",
            size: "lg",
            "cancel-text": "Hủy",
            "confirm-text": "Lưu lại",
            "confirm-loading": _vm.loading,
            "use-panel": false,
            top: "6vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            confirm: _vm.handleSubmit,
            cancel: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticClass: "sk-dialog-content",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.formRules,
                "label-width": "170px",
                "label-position": "left",
              },
            },
            [
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-document" }),
                    ]),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thông tin khoản thu"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Thông tin cơ bản của khoản thu (chỉ xem)"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Tên khoản thu" } },
                            [
                              _c("div", { staticClass: "erd-readonly-value" }, [
                                _vm._v(_vm._s(_vm.dataForm.revenueName || "—")),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.description
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Mô tả" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "erd-readonly-value erd-description",
                                    },
                                    [_vm._v(_vm._s(_vm.dataForm.description))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Tính theo điểm danh" } },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.dataForm.attendance
                                      ? "primary"
                                      : "info",
                                    size: "small",
                                    effect: "light",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.dataForm.attendance ? "Có" : "Không"
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Áp dụng công thức" } },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.dataForm.hasFormula
                                      ? "primary"
                                      : "info",
                                    size: "small",
                                    effect: "light",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.dataForm.hasFormula ? "Có" : "Không"
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.hasFormula && _vm.dataForm.formulaExpression
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Biểu thức công thức" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "erd-readonly-value erd-formula",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.dataForm.formulaExpression)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.hasFormula && _vm.dataForm.formulaExpression
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                  Công thức (đã dịch)\n                  "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Công thức với tên khoản thu thay thế biến",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question erd-help-icon ml-1",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2435694460
                                  ),
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "trf-formula-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dataForm.formulaExpressionName
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--success" },
                      [_c("i", { staticClass: "el-icon-money" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Tài chính ghi đè"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Điều chỉnh giá, số lượng và giảm giá riêng cho học sinh này"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      !_vm.dataForm.hasFormula
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "price" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                  Đơn giá (VNĐ)\n                  "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Đơn giá ghi đè cho học sinh này",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question erd-help-icon ml-1",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2230778645
                                  ),
                                },
                                [
                                  _c("ElCurrencyInput", {
                                    staticClass: "sk-u-w-full",
                                    attrs: {
                                      options: {
                                        locale: "vi-VN",
                                        precision: 0,
                                        autoDecimalMode: false,
                                        distractionFree: false,
                                      },
                                    },
                                    on: { input: _vm.calculatePreview },
                                    model: {
                                      value: _vm.dataForm.price,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.dataForm, "price", $$v)
                                      },
                                      expression: "dataForm.price",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "quantity" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                  Số lượng\n                  "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: "Số lượng đơn vị",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question erd-help-icon ml-1",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input", {
                                staticClass: "sk-u-w-full",
                                attrs: {
                                  type: "number",
                                  step: _vm.allowDecimal ? 0.01 : 1,
                                },
                                on: { input: _vm.calculatePreview },
                                model: {
                                  value: _vm.dataForm.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "quantity",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "dataForm.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Cho phép số thập phân" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  value: _vm.allowDecimal,
                                  "active-text": "Có",
                                  "inactive-text": "Không",
                                },
                                on: { change: _vm.handleAllowDecimalChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                  Đơn vị tính\n                  "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Ví dụ: tháng, buổi, lần...",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question erd-help-icon ml-1",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "sk-u-w-full",
                                  attrs: {
                                    filterable: "",
                                    "allow-create": "",
                                    "default-first-option": "",
                                    placeholder: "Chọn hoặc nhập đơn vị",
                                  },
                                  model: {
                                    value: _vm.dataForm.unit,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "unit", $$v)
                                    },
                                    expression: "dataForm.unit",
                                  },
                                },
                                _vm._l(_vm.unitsList, function (u) {
                                  return _c("el-option", {
                                    key: u,
                                    attrs: { label: u, value: u },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "discount" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                  Giảm giá\n                  "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Bật nếu muốn áp dụng chính sách giảm giá riêng cho học sinh này",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question erd-help-icon ml-1",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.onDiscountChange },
                                  model: {
                                    value: _vm.dataForm.discount,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "discount", $$v)
                                    },
                                    expression: "dataForm.discount",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("Có"),
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("Không"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.discount
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "discountType" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                  Loại giảm giá\n                  "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Phần trăm (%) hoặc số tiền (VNĐ)",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question erd-help-icon ml-1",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3891659097
                                  ),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "sk-u-w-full",
                                      attrs: { placeholder: "Chọn loại" },
                                      on: { change: _vm.calculatePreview },
                                      model: {
                                        value: _vm.dataForm.discountType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "discountType",
                                            $$v
                                          )
                                        },
                                        expression: "dataForm.discountType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "Phần trăm (%)",
                                          value: "PERCENT",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Số tiền (VNĐ)",
                                          value: "MONEY",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.discount
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "discountNumber" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm.dataForm.discountType ===
                                            "PERCENT"
                                              ? _c("span", [
                                                  _vm._v("Phần trăm giảm (%)"),
                                                ])
                                              : _c("span", [
                                                  _vm._v("Số tiền giảm (VNĐ)"),
                                                ]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    568855960
                                  ),
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center" },
                                    [
                                      _vm.dataForm.discountType === "MONEY"
                                        ? [
                                            _c("ElCurrencyInput", {
                                              staticClass: "sk-u-w-full",
                                              attrs: {
                                                options: {
                                                  locale: "vi-VN",
                                                  precision: 0,
                                                  autoDecimalMode: false,
                                                  distractionFree: false,
                                                },
                                              },
                                              on: {
                                                input: _vm.calculatePreview,
                                              },
                                              model: {
                                                value:
                                                  _vm.dataForm.discountNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataForm,
                                                    "discountNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataForm.discountNumber",
                                              },
                                            }),
                                          ]
                                        : [
                                            _c("el-input-number", {
                                              directives: [
                                                {
                                                  name: "discount-percent",
                                                  rawName: "v-discount-percent",
                                                },
                                              ],
                                              staticClass: "sk-u-w-full",
                                              attrs: {
                                                min: 0,
                                                max: 100,
                                                precision: 0,
                                                "controls-position": "right",
                                              },
                                              on: {
                                                change: _vm.calculatePreview,
                                              },
                                              model: {
                                                value:
                                                  _vm.dataForm.discountNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataForm,
                                                    "discountNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataForm.discountNumber",
                                              },
                                            }),
                                          ],
                                      _vm.discountAmount > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "erd-discount-amount ml-3",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    -" +
                                                  _vm._s(
                                                    _vm.formatMoney(
                                                      _vm.discountAmount
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      Number(_vm.dataForm.taxPercentage) > 0
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Thuế suất" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "erd-readonly-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          Number(_vm.dataForm.taxPercentage)
                                        ) + "%"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.dataForm.hasFormula
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [_vm._v("Thành tiền")]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2661737267
                                  ),
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "erd-preview-money" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatMoney(_vm.previewSumMoney)
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.dataForm.hasFormula
                ? _c("principal-override-table", {
                    attrs: {
                      overrides: _vm.principalOverrides,
                      "formula-expression": _vm.dataForm.formulaExpression,
                      loading: _vm.overrideLoading,
                      resetting: _vm.overrideResetting,
                    },
                    on: {
                      edit: _vm.openOverrideEditDialog,
                      reset: _vm.handleResetOverrides,
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "sk-panel mb-2" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                      [_c("i", { staticClass: "el-icon-tickets" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Hóa đơn điện tử"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Cài đặt phát hành hóa đơn điện tử cho khoản thu này"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                  Hóa đơn điện tử\n                  "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Bật nếu khoản thu cần phát hành hóa đơn điện tử",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question erd-help-icon ml-1",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.dataForm.issuingElectronicInvoices,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataForm,
                                        "issuingElectronicInvoices",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataForm.issuingElectronicInvoices",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("Có"),
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("Không"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("principal-override-edit-dialog", {
        ref: "overrideEditDialog",
        on: { saved: _vm.onOverrideSaved },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }